/**
 * The quarter list a publish covers.
 *
 * Derived from productDb's OWN pricing keys — 14 for AIC (2025-Q3..2028-Q4) —
 * NOT from quarterMapping, which lists only the 12 SELLABLE quarters and omits
 * 2025-Q3/Q4. A past quarter must still resolve for an already-saved
 * configuration; pruning belongs in the dropdown, not in the price sheet.
 *
 * This module resolves per-vendor productDb through the vendor registry (no direct
 * JSON import). priceBookFromEdition remains the only direct productDb importer.
 * Both are named migration targets for the day the catalog carries SKUs and specs
 * itself.
 */
import { quartersFromProductDb } from './seedBuilder';
import type { ProductDb } from './priceBookFromEdition';
import VENDORS from '../config/vendorRegistry';

/**
 * THE vendor -> productDb lookup. Exported so the publish coverage guard can
 * ask "what does productDb price this quarter" without becoming a third
 * productDb importer (see this file's header). Resolves any registered vendor
 * via the registry rather than a hardcoded map.
 */
export function productDbFor(vendor: string): ProductDb {
  const db = (VENDORS as Record<string, any>)[vendor]?.databases?.products;
  if (!db) throw new Error(`unknown vendor "${vendor}" — no productDb registered`);
  return db as ProductDb;
}

export function publishQuarters(vendor: string): string[] {
  return quartersFromProductDb(productDbFor(vendor));
}
